import { Action, action } from 'easy-peasy';

export interface CounterModel {
  count: number;
  increment: Action<CounterModel>;
  decrement: Action<CounterModel>;
}

const counter: CounterModel = {
  count: 0,
  increment: action(state => {
    state.count += 1;
  }),
  decrement: action(state => {
    state.count -= 1;
  }),
};

export default counter;
